export default function () {
    document.querySelectorAll('.nav-tabs').forEach((nav) => {
        nav.addEventListener('wheel', (event) => {
            if (nav.scrollWidth <= nav.clientWidth) {
                return;
            }
            if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) {
                return;
            }
            event.preventDefault();
            nav.scrollLeft += event.deltaY;
        }, {passive: false});
    });
}
